import { getConfigByGroup } from '@/api/globalconfig'
import Vue from 'vue'

const globalconfig = {
    namespaced: true,
    state: {
        configList: []
    },
    mutations: {
        setList (state, list) {
            state.configList = list
        }
    },
    actions: {
        async upadteConfig (context, params) {
            try {
                const res = await getConfigByGroup('FrontEndView')
                context.commit('setList', res)
                Vue.prototype.$eventBus.$emit('global-config-loaded')
            } catch (error) {
                throw error
            }
        }
    }
}

export default globalconfig
